export default "__VITE_ASSET__c1b30af9__"